(function() { window.GUID_a7797bd8_5db3_4024_98a2_a46c3af108a7 = { getGuid: function() { return "a7797bd8-5db3-4024-98a2-a46c3af108a7"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Controls;
    (function (Controls) {
        var Base;
        (function (Base) {
            class BaseControl {
            }
            Base.BaseControl = BaseControl;
        })(Base = Controls.Base || (Controls.Base = {}));
    })(Controls = CompuSport.Controls || (CompuSport.Controls = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=BaseControl.js.map
